import React, { useState } from 'react';
//import dadesbancaries from '../data/dadesbancaries.json'
//import assignatures from '../data/assignatures.json'
import llista_bonificacions from '../../../data/llista_bonificacions.json'
import config from '../../../config';
import { textPlaAHtml, htmlDesat } from './formatText'
//import llistaExemptesPagament from '../../../data/llista_exemptes_pagament.cavallbernat.json'
//import llistaExemptesPagamentAmbLlibres from '../../../data/llista_exemptes_pagament_amb_llibres.cavallbernat.json'

// abans es carregaven amb require() en temps de build; ara arriben en viu des de l'API
// (amb el mateix fallback als JSON estàtics al servidor), injectades per studies.*.js
// via setCataleg() un cop resolt el fetch
let dadesbancaries = {}
let assignatures = {}

export function setCataleg(novesAssignatures, novesDadesBancaries) {
  assignatures = novesAssignatures ?? assignatures
  dadesbancaries = novesDadesBancaries ?? dadesbancaries
}


const exemptPagament = (iddocument,becat) => {
  if( becat === "B") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagament.filter( id => id === iddocument ).length > 0
  return false
}

const exemptPagamentAmbLlibres = (iddocument,becat) => {
  if( becat === "L") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagamentAmbLlibres.filter( id => id === iddocument ).length > 0
  return false
}


export function calculQuota(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne ) {

let quota = {
             matricula: 0,
             asseguranca: 0,
             material: 0,
             formacio: 0,
             bonificacio: 0,
             moduls: 0,
             total: 0,
             dadesbancaries: dadesbancaries }

/* controls que impedeixen que es calcul la quota sense tenir les dades corresponents necessaries per al càlcul */
if(dataNaixement === undefined) return quota
if(curs === undefined) return quota
if(curs?.id === undefined) return quota
if (!assignatures[curs.id]) return quota // catàleg encara no ha arribat de l'API

// busquem nivell maxim de assignatura (només cal que en tinguin una de 2n per ser matricula de 2n curs)
let nivellMax = 0
const llistaAssignatures = assignatures[curs.id]
  llistaAssignatures.map((ll) => {
    ll.subjects.map((s) => { 

      if(assignaturesTriades.includes(s.id))
      {
          if(s.level > nivellMax)
          {
              nivellMax = s.level
          }
        }
    }
    )
  })

  setNivellMax(nivellMax)

  //if(nivellMax === 2 && !props.nouAlumne ) setRepetidor(2)



let temps= new Date()
temps.setFullYear(new Date().getFullYear() - 28)

  quota.menor28 = dataNaixement.getTime() >= temps.getTime() ? true : false

  const quotaAsseguranca = (menor28) => {

    if (menor28) {
      return 1.12
    }
      
    return 0
  }

  const quotaMaterial = (curs) => {

    if (curs.material === undefined ) return 0

    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
            return mats.push({...m,checked: m.check })
      })

      //console.log("MATS",mats)

      setMaterials(mats)
    }


    let totalMaterials =  0

      materials.map((m) => 
      { 

          if(m.checked) totalMaterials += m.preu
            
      })

      
    return totalMaterials
  }

  const quotaBonificacio = (matricula,bonificacio) => {

    const bon = llista_bonificacions.filter(b => b.id === bonificacio ).pop()

    if (!bon) return 0

    switch (bon.descompte) {
      case '50%': return matricula / 2;
      case '100%': return matricula;
      default: return 0;
    }
  }


//const quotaCFGM = (quota, assignaturesTriades, preuModuls1, preuModuls2 ) => {
const quotaCFGM = (quota, assignaturesTriades) => {

//const preuUF = 25
const preuFCT = 0

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {


    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu

          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //quota.matricula = 0

    /* moduls */
    quota.moduls = 0


    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar pero les de segon en matricula parcial si
      //const assignaturesTriadesN = assignaturesTriades.filter((ass) => !/^FCT.2/.test(ass)).length

      /*
      console.log("DEBUG",
      Math.ceil((llistaAssignaturesPrimer.length)/2),'>',(Object.keys(llistaBlocsPrimer).length),
      '=>',
      Math.ceil((llistaAssignaturesPrimer.length)/2)>(Object.keys(llistaBlocsPrimer).length),
      '&&',
      Math.ceil((llistaAssignaturesSegon.length)/2)>(Object.keys(llistaBlocsSegon).length),
      '&&',
      Math.ceil((llistaAssignaturesPrimer.length+llistaAssignaturesSegon.length)/4)>(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length)
    )
      */


    // no massa segur del últim criteri
      if(
      Math.ceil((llistaAssignaturesPrimer.length)/2)>(Object.keys(llistaBlocsPrimer).length)
      &&
      Math.ceil((llistaAssignaturesSegon.length)/2)>(Object.keys(llistaBlocsSegon).length)
      &&
      Math.ceil((llistaAssignaturesPrimer.length+llistaAssignaturesSegon.length)/4)>(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length)
      ) {
         // <50%  agafat

        quota.moduls =  40

      }
      else
      {
        // + 50% agafat => com curs sencer

       quota.moduls =  80
      }


      // si no han agafat cap assignatura de primer ni de segon, és només estada en empresa per tant cobrem nonés el següent, sinó sumem les dues coses
     if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0]))  quota.moduls = 0

      //if(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length === 0) 

      /* CALCUL QUOTA NOMÉS ESTADA EN EMPRESA */
      assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 

    }

    /*
    // preu 1r
    if (matricula_parcial_1r) {
      quota.moduls += preuModuls1 * Object.keys(llistaBlocsPrimer).length
    }

    // preu 2n
    if (matricula_parcial_2n) {
      quota.moduls += preuModuls2 * Object.keys(llistaBlocsSegon).length
    }
    */


  }

  quota.total += quota.moduls + quota.matricula


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material = quotaMaterial(curs,nouAlumne)
  }
  quota.total += quota.material

  //DEBUG console.log("QUOTA M",quota)

  // total
  return quota;
}


const quotaCFGM_CFPMAE10 = (quota, assignaturesTriades) => { // CFGM Guia en el medi natural i de temps de lleure

//const preuUF = 25
const preuTotalMax= 1116.12 // cal revisar cada any o passar a calcular-lo automàticament
const preuFCT = 0

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //quota.matricula = 0

    /* moduls */
    quota.moduls = 0

    if (matricula_parcial_1r && matricula_parcial_2n) {
      quota.moduls = 0 

      // Les FCT no computen com a assignatura a pagar 
      assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
    }

  }

  quota.total += quota.moduls + quota.matricula


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material = quotaMaterial(curs,nouAlumne)
  }
  quota.total += quota.material

  //DEBUG console.log("QUOTA M",quota)

  if(quota.total > preuTotalMax) quota.total = preuTotalMax
  // total
  return quota;
}


// quota CFGS nou pla d'estudis
const quotaCFGS = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2) => {

  const preuFCT = 65
  const preuFCTModul = 0
  const preuMatricula = 360
  const preuUF = 65

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    quota.moduls = preuFCTModul

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu

          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)



    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass)).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


    /* calcul cost material per soltes */
    /* moduls */
    quota.moduls = 0


    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar pero les de segon en matricula parcial si
      //const assignaturesTriadesN = assignaturesTriades.filter((ass) => !/^FCT.2/.test(ass)).length


    // no massa segur del últim criteri
      if(
      Math.ceil((llistaAssignaturesPrimer.length)/2)>(Object.keys(llistaBlocsPrimer).length)
      &&
      Math.ceil((llistaAssignaturesSegon.length)/2)>(Object.keys(llistaBlocsSegon).length)
      &&
      Math.ceil((llistaAssignaturesPrimer.length+llistaAssignaturesSegon.length)/4)>(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length)
      ) {
         // <50%  agafat


         /*
      if( assignaturesTriadesN <= 2)
      {
       quota.moduls =  16.88 // una o dues UF / moduls
      }
      else {
        quota.moduls =  38.88 // parcial menys del 50%
      }
        */
        quota.moduls =  40 // parcial menys del 50%


      }
      else
      {
        // + 50% agafat => com curs sencer

       quota.moduls =  80
      }
    }


      // si no han agafat cap assignatura de primer ni de segon, és només estada en empresa per tant cobrem nonés el següent, sinó sumem les dues coses
     if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0]))  
      {
         quota.moduls = 0
         quota.matricula = 0

      }

      //if(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length === 0) 

      /* CALCUL QUOTA NOMÉS ESTADA EN EMPRESA */
      assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 

  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls)


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio
    
    quota.material = quotaMaterial(curs,nouAlumne)

    quota.total += quota.material
  }

  return quota;
}

const quotaCFGS_CFPSAEB0 = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2) => {

  const preuFCT = 25
  const preuFCTModul = 0
  const preuMatricula = 360
  const preuUF = 25

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    quota.moduls = preuFCTModul

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      
      bloc.subjects.map(
        (assignatura) => {
          
          llistaPreus[assignatura.id] = assignatura.preu
          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)



    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass)).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


    /* calcul cost material per soltes */
    /* moduls */
    quota.moduls = 0

    /* calcul de material si agafen soltes */

    if (matricula_parcial_1r && matricula_parcial_2n ) {
          // Les FCT no computen com a assignatura a pagar 
          //assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
          assignaturesTriades.filter((ass) => !/^NEE/.test(ass) && /^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
        }


      // si no han agafat cap assignatura de primer ni de segon, és només estada en empresa per tant cobrem nonés el següent, sinó sumem les dues coses
     if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0]))  
      {
         quota.moduls = 0
         quota.matricula = 0

      }

      //if(Object.keys(llistaBlocsPrimer).length+Object.keys(llistaBlocsSegon).length === 0) 

      /* CALCUL QUOTA NOMÉS ESTADA EN EMPRESA */
      assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 


  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls)


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio
    
    quota.material = quotaMaterial(curs,nouAlumne)

    quota.total += quota.material
  }

  return quota;
}


// iniciem a 'null'
let formacio = undefined
let llistaAssignaturesPrimer =  []
let llistaAssignaturesSegon =  []
let matricula_parcial_1r = true;
let matricula_parcial_2n = true;
//let matricula_parcial_1r_count = 0;
//let matricula_parcial_2n_count = 0;

quota.asseguranca = 0;
quota.material = 0;
quota.total = 0;

switch(curs.id)
{
  /*
    CFPMAE10  CFGM Guia en el medi natural i de temps de lleure
    CFPMAG10  CFGM Gestió administrativa
    CFPMEE10  CFGM Instal·lacions elèctriques i automàtiques
    CFPMIC10  CFGM Sistemes microinformàtics i xarxes

    CFPSAEB0  CFGS Condicionament físic
    CFPSAGB0  CFGS Administració i finances
    CFPSAGA0  CFGS Assistència a la direcció
    CFPSEOB1  CFGS Projectes d’Edificació, perfil professional Rehabilitació i Restauració
    CFPSEEA0  CFGS Sistemes electrotècnics i automatitzats
    CFPSICC0  CFGS Desenvolupament d’aplicacions web
    CFPSICA1  CFGS Administració de sistemes informàtics en xarxa – Especialitat Ciberseguretat
  */

    // MITJOS

  case "CFPMAE10": //CFGM Guia en el medi natural i de temps de lleure
  case "CFPMAE10A":
    return quotaCFGM_CFPMAE10(quota, assignaturesTriades)

  case "CFPMAG10": //CFGM Gestió administrativa
  case "CFPMAG10A":

  case "CFPMEE10": //CFGM Instal·lacions elèctriques i automàtiques
  case "CFPMEE10A":

  case "CFPMIC10": //CFGM Sistemes microinformàtics i xarxes
  case "CFPMIC10A":
    return quotaCFGM(quota, assignaturesTriades)


    // SUPERIOR

  case "CFPSAEB0": //CFGS Condicionament físic
  case "CFPSAEB0A":
    return quotaCFGS_CFPSAEB0(quota, assignaturesTriades, 0, 0, 0)

  case "CFPSAGB0": //CFGS Administració i finances
  case "CFPSAGB0A": 

  case "CFPSAGA0": //CFGS Assistència a la direcció
  case "CFPSAGA0A":

  case "CFPSEOB1": //CFGS Projectes d’Edificació, perfil professional Rehabilitació i Restauració
  case "CFPSEOB1A":

  case "CFPSEEA0": //CFGS Sistemes electrotècnics i automatitzats
  case "CFPSEEA0A":

  case "CFPSICC0": //CFGS Desenvolupament d’aplicacions web
  case "CFPSICC0A": 

  case "CFPSICA1": //CFGS Administració de sistemes informàtics en xarxa – Especialitat Ciberseguretat
  case "CFPSICA1A":
    return quotaCFGS(quota, assignaturesTriades, 0, 0, 0)

  // PFI
  case "PFIAG01":
  case "PFIIC01":
  case "PFIEE01":
  case "PFIAE01":

                    /*
                    // assegurança
                    quota.asseguranca = quotaAsseguranca(quota.menor28)
                    quota.total += quota.asseguranca

                    quota.matricula = 0;
                    quota.total += quota.matricula

                    // material
                    quota.material = quotaMaterial(curs)
                    quota.total += quota.material
                    */

                    // total
                    return quota;

  default: return quota;
      
}

}


/*****************************************
 * 
 * MostraQuota
 * 
 * 
 * 
 */

export const MostraQuota = (props)  => {

let quota = props.quota
const [bonificacio, setBonificacio] = useState([]);

const handleChangeRepetidor = (v) => {
  props.setRepetidor(v)

  //checkMaterials()
}


const canviaPreuMaterial = (id,preu) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.preu = preu )

  props.setMaterials(mat)

}

const canviaTxtMaterial = (id,txt) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.txt = txt )

  props.setMaterials(mat)

}


const handleChangeMaterial = (t) => {

//console.log("MAT0",t)

let mat = [...props.materials]

//console.log("MAT1",mat)

  mat.filter(item => item.id === t).map( (i) => i.checked = !i.checked )

//console.log("MAT2",mat)

  props.setMaterials(mat)

}

const isMaterialChecked = (id) => {

let mat = props.materials.filter(item => item.id === id).pop()

if(mat === undefined ) return false
return mat.checked
}


const handleChangeBonificacions = (t) => {
  //console.log(t)
  props.setBonificacions(t)
  setBonificacio(t)
}

const handleChangeTerminis = (t) => {
  props.setDosTerminis(t)
}


// calcul quotes  / terminis
//console.log("2T", props.dosTerminis);
if (props.dosTerminis) {

  switch(props.cicle)
  {

    //50%-50%
    case "CFGS": 
      quota.termini1 =  quota.total / 2
      quota.termini2 =  quota.total - quota.termini1
        break

    //50%-50%
    default:
    case "CFGM": 
        quota.termini1 =  quota.total / 2
        quota.termini2 =  quota.total - quota.termini1
        break
  }

}
else {
  quota.termini1 = undefined
  quota.termini2 = undefined
}

let enguany = new Date().getFullYear()
let anyVinent = enguany + 1
anyVinent = anyVinent.toString().slice(-2)

  return (
    <div className="col col-12">

      <div className="row">
        <div className="t-Form-labelContainer">
          <label className="t-Form-label"> Quota de pagament del curs escolar {enguany}/{anyVinent}</label>
        </div>
      </div>

      <div className="row">
      <div className="col quota">


        <div className="quotaTitol">Curs: {props.curs.value} ({props.curs.id})</div>

        <div className="quotaDadesBancaries">

        { quota.total >0 && ( quota.dadesbancaries.IBAN && ( <>

          <div><span className="quotaNomCamp">Entitat bancària:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.entitat)} /></div>

          <div> <span className="quotaNomCamp">nº IBAN:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.IBAN)} /></div>

          </>) ) }

          <div className="quotaDadesPagamentCalendari"><span className="quotaNomCamp">Condicions:</span> <span dangerouslySetInnerHTML={htmlDesat(quota.dadesbancaries.condicions[props.curs.condicions])} /></div>

        </div>

        <label> Conceptes </label>

        <table className="quota table">
          <tbody>

              { ( !props.curs.id.startsWith("ESO") && !props.curs.id.startsWith("BATX") ) &&
                (<>
                  <tr>
                    <th className="quotaNomCamp" colspan="2">Assegurança escolar obligatòria: </th>
                  </tr>

                  <tr>
                    {quota.menor28 && (<td className="col">Alumnat menor de 28 anys</td>)}
                    {!quota.menor28 && (<td className="col">Alumnat de 28 anys i major</td>)}
                    <td>{(quota.asseguranca).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>
                  </tr>
                </>) }

          {/*props.nouAlumne !== true && (
          <>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor0" name="repetidor" value="0" defaultChecked={ props.repetidor === 0 } onChange={(e) => handleChangeRepetidor(0)} ></input>
             <label for="repetidor0">Promociona a 2n</label></td>
          </tr>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor1" name="repetidor" value="1" defaultChecked={ props.repetidor === 1 } onChange={(e) => handleChangeRepetidor(1)} ></input>
             <label for="repetidor1">Repetidor 1r</label></td>
          </tr>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor2" name="repetidor" value="2" defaultChecked={ props.repetidor === 2 } onChange={(e) => handleChangeRepetidor(2)} ></input>
             <label for="repetidor2">Repetidor 2n</label></td>
          </tr>
          </>
          )
        */}

          { quota.moduls > 0 && (
          <tr>
            <td>Material mòduls matriculats:</td>
            <td>{(quota.moduls).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          { quota.matricula > 0 && (
          <tr>
            <td>{ props.curs.id.startsWith("CFPM") ? "Material curs:" : "Taxes:" }</td>
            <td>{(quota.matricula).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }



          {props.curs?.bonificacions === true && (<tr><th colspan="2" className="quotaNomCamp">Bonificacions / Exempcions:</th></tr>)}


          {props.curs?.bonificacions === true && (
                <tr>
                  <td>
                    <select id="bonificacions" name="bonificacions" defaultValue={bonificacio} onChange={(e) => handleChangeBonificacions(e.target.value)}>
                      {llista_bonificacions.map((m, k) =>
                        <option key={k} id={m.id} name={m.id} value={m.id}>{m.valor} ({m.descompte})</option>
                      )}
                    </select>
                  </td>
                  <td>
                    {quota.bonificacio >0 && "-"+(quota.bonificacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })+ "€" }
                  </td>
                </tr>
          )}

          { quota.formacio > 0 && (<tr><td className="quotaNomCamp">Despeses de formació:</td><td>{(quota.formacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>)}

          { /*quota.material > 0 && (<tr><td className="quotaNomCamp">Material del cicle:</td><td>{(quota.material).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>) */}


          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?

            (
              <>
              <tr><th colspan="2" className="quotaNomCamp">Preu curs escolar:</th></tr>
              </>

            ) 
            : 
            (
              <>
              {/* Si l'import del material és 0 no cal mostrar */}
              {quota.material <=0 && (<tr><td className="quotaNomCamp"></td> </tr>)}
              {quota.material >0 && (<tr><th colspan="2" className="quotaNomCamp">Material específic del cicle:</th></tr>)}
              </>
            )}

          {props.curs.material && props.curs.material.map((m, p) => {

            let disabled = false

            if ( props.assignatures?.length === 1 && /^FCT/.test(props.assignatures[0]) ) { // si només fan FCT no hi ha mai material
                return false
            } 
            else
            {

              let preu_material = 0;

              // MATERIALS
              switch (props.curs.id) 
              {

              /* CICLES MITJOS */
              case "CFPMAE10": //CFGM Guia en el medi natural i de temps de lleure
              case "CFPMAE10A":

              case "CFPMAG10": //CFGM Gestió administrativa
              case "CFPMAG10A":

              case "CFPMEE10": //CFGM Instal·lacions elèctriques i automàtiques
              case "CFPMEE10A":

              case "CFPMIC10": //CFGM Sistemes microinformàtics i xarxes
              case "CFPMIC10A":


              /* CICLES SUPERIORS */
              case "CFPSAEB0": //CFGS Condicionament físic
              case "CFPSAEB0A":

              case "CFPSAGB0": //CFGS Administració i finances
              case "CFPSAGB0A":

              case "CFPSAGA0": //CFGS Assistència a la direcció
              case "CFPSAGA0A":

              case "CFPSEOB1": //CFGS Projectes d’Edificació, perfil professional Rehabilitació i Restauració
              case "CFPSEOB1A":

              case "CFPSEEA0": //CFGS Sistemes electrotècnics i automatitzats
              case "CFPSEEA0A":

              case "CFPSICC0": //CFGS Desenvolupament d’aplicacions web
              case "CFPSICC0A":

              case "CFPSICA1": //CFGS Administració de sistemes informàtics en xarxa – Especialitat Ciberseguretat
              case "CFPSICA1A":

                  const llistaAssignaturesPrimer = []
                  const llistaAssignaturesSegon = []

                  assignatures[props.curs.id].map((bloc) => {
                    bloc.subjects.map(
                      (assignatura) => {
                        if (assignatura.level === 1) { llistaAssignaturesPrimer.push(assignatura.id) }
                        if (assignatura.level === 2) { llistaAssignaturesSegon.push(assignatura.id) }
                      }
                    )
                  }
                  )

                  let matricula_parcial_1r = true;
                  if (llistaAssignaturesPrimer.length > 0) {
                    let copiaAssignatures1r = [...llistaAssignaturesPrimer]

                    matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }

                  let matricula_parcial_2n = true;
                  if (llistaAssignaturesSegon.length > 0) {
                    let copiaAssignatures2n = [...llistaAssignaturesSegon]

                    matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }

            // Material curs
            if(m.id=== "material")
            {

              // per mantenir el preu original en el cas que s'hagi de canviar a 0 i posteriorment restaurar
              m.preuOrig = m.preuOrig ?? m.preu
              m.txtOrig = m.txtOrig ?? m.txt

              //matricula completa
              if (!matricula_parcial_1r || !matricula_parcial_2n) 
              {
                if (m.preu !== m.preuOrig) {
                  m.preu = m.preuOrig
                  m.txt = m.txtOrig
                  canviaPreuMaterial(m.id, m.preu)
                  canviaTxtMaterial(m.id, m.txt)
                }
              }
              else  //matricula parcial
              {
                if (m.preu !== 0) {
                  m.preuOrig = m.preu
                  m.txtOrig= m.txt
                  m.preu = 0
                  m.txt = "Material curs"
                  canviaPreuMaterial(m.id, m.preu)
                  canviaTxtMaterial(m.id, m.txt)
                }
              }


              // sempre obligatori - només canvia preu si no és necessari pel curs
              disabled = true;
              break;
            }


            // associació alumnes
            if( m.id === "ampa")
            {
                  disabled = false; 
                  break; 
            }


            // PFI
            case "PFIAG01":
            case "PFIIC01":
            case "PFIEE01":
            case "PFIAE01":
            default:
                    disabled = true; 
                    break; 

              }
            }




            /* si els dos terminis no estan activats mostrem altres condicions de pagament */
          if(!config.dosTerminisEnabled) { props.curs.condicions = config.dosTerminisEnabledFalseCondicio } 

          return (
            <>
           { m.preu > 0 && (<tr>
            <td>
            <input type="checkbox" id={m.id} name={m.id} value={m.preu} checked={isMaterialChecked(m.id)} disabled={disabled} onChange={(e) => handleChangeMaterial(e.target.id)} />
            <label for={m.id}>{m.txt}</label>
            </td>
            <td>
            {m.preu}&euro;
          </td></tr>)}

              {/* isMaterialChecked(m.id) && m.info !== undefined ?*/}
              { m.info !== undefined && m.info !== ""?
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }} dangerouslySetInnerHTML={{ __html: m.info }} />
                      </td>
                      <td>
                      </td>
                    </tr>)
                    : null
                }

          </>
          )}
          )}

          <tr><th className="quotaNomCamp" colSpan="2"> Total a abonar a compte:</th></tr>

          <tr>

          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?
          (<>
           <td>Total: 
           { 
           exemptPagament(props.iddocument,props.becat) ? 
           ( <small>&nbsp;<i>Exempt de pagament de matrícula i llibres</i></small>)
           : exemptPagamentAmbLlibres(props.iddocument,props.becat) && ( <small>&nbsp;<i>Exempt del pagament de la matrícula (material i sortides) si que s'hauran de comprar els llibres.</i></small>)}
           
            </td>
          </>)
          :
          (<>
          { quota.menor28 ? (<td>Alumnat menor de 28 anys</td>) : (<td>Alumnat de 28 anys i major: </td>)}
          </>) 
          }

           <td className="quotaTotal"> {(quota.total).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>

          </tr>



          <tr>
          { !quota.menor28 && (<td colSpan={2}>

            <small><i>(Els alumnes més grans de 28 anys que disposin de la targeta sanitària del Servei Català de la Salut tenen coberta l'assistència sanitària, però no tenen dret a les prestacions que dona l'assegurança escolar obligatòria.)</i></small>

          </td>)}

          </tr>

          { ( props.curs.condicions === 1 && config.dosTerminisEnabled ) && 

          (quota.bonificacio < quota.matricula || quota.bonificacio === 0) && quota.total >= 100 ? 

          (<tr>
            <td colspan="2">
            <input type="checkbox" id="dosTerminis" name="dosTerminis" value={true} checked={props.dosTerminis} onChange={(e) => props.setDosTerminis(e.target.checked)} />
            <label for="dosTerminis">Vull fer el pagament en 2 terminis</label>
            </td>
            <td>
          </td></tr>)
          : (<>{props.setDosTerminis(false)}</>)

          }


           { props.dosTerminis && (
              <React.Fragment>
              <tr>
                <td>
                  Pagament 1r termini:
                </td>
                <td>
                  { quota.termini1 && (quota.termini1).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              <tr>
                <td>
                  Pagament 2n termini:
                </td>
                <td>
                  { quota.termini2 && (quota.termini2).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              </React.Fragment>
            )}

          </tbody>
        </table>

      </div>
      </div>

    </div >
  )
  
 }
